module.exports = __webpack_public_path__ + "img/b1-3.fe2a3ba.png";